<template>
  <v-progress-circular
    :size="100"
    :width="15"
    :rotate="360"
    :value="value * 2"
    color="primary"
  >
    {{ value }}
  </v-progress-circular>
</template>


<script>
  export default {
    props: ['tick'],
    data () {
      return {
        interval: {},
        value: 0
      }
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          clearInterval(this.interval)
        }
        this.value += 10
      }, this.tick)
    }
  }
</script>


// WEBPACK FOOTER //
// Loader.vue?8c49ed3a